function shadowRootParentOrDocument(el) {
  const element = el.getRootNode().host || el.getRootNode();
  if (element.shadowRoot) {
    return element.shadowRoot;
  }
  return document;
}

export default shadowRootParentOrDocument;

/**
 * This function check for attributes atrributes delared with 'input-' are attributes for
 * input element inside component .
 * This is generic function which check for props need to be passed
 *TODO :we can make it more generic by passing which child element we have to pass attributes like input but that is future scope
 *
 * @param {NamedNodeMap} nodeMap --Element attribute passed
 */

export function getElementAttributes(nodeMap: NamedNodeMap) {
  if (!nodeMap) return {};
  const { length } = nodeMap;
  const pattern = /^data-input-/i;
  let props = {};
  for (let i = 0; i < length; i++) {
    const property = nodeMap.item(i);
    if (pattern.test(property.name)) {
      const propertyName = property.name.replace('data-input-', '');
      props = {
        ...props,
        [propertyName]: property.value,
      };
    }
  }
  return props;
}

/**
 * This function sets attributes to element
 * @param {Element} el
 * @param {Object}  attrs all attributes
 */

export function setAttributes(el, attrs) {
  for (const key in attrs) {
    if (attrs[key]) {
      el.setAttribute(key, attrs[key]);
    }
  }
}
